import { Table, TableHead, TableRow, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { useState } from "react";
import five from "../../../src/assets/images/five.png";
import four from "../../../src/assets/images/four.png";
import one from "../../../src/assets/images/one.png";
import three from "../../../src/assets/images/three.png";
import two from "../../../src/assets/images/two.png";

import DownloadIcon from "@mui/icons-material/Download";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import Modal from "../Modal/Modal";
import MUITable from "./../../Component/UI/Table/Table";
import SentimentItem from "./SentimentItem";
import classes from "./SentimentTable.module.css";

export function trimBeforeInstructions(text) {
  const pattern = /instructions\s*:\s*1\s*\.\s*create\s*a\s*single\s*paragraph\s*of\s*exactly/i;
  const match = text.match(pattern);

  if (match) {
    const index = match.index;
    return text.substring(0, index).trim();
  }

  return text;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function SentimentTable({ data, showScore = true }) {
  const [showSentimentModal, setShowSentimentModal] = useState(false);
  const [selectedSentiment, setSelectedSentiment] = useState({
    data: null,
    number: 0,
  });

  const sentiments = data?.sentimentMeta || [];

  function getSentimentIcon(llm_sentiment) {
    let sentimentIcon = "";
    switch (llm_sentiment) {
      case "Positive":
        sentimentIcon = <img height={30} width={30} src={five} alt="5" />;
        break;
      case "Slightly Positive":
        sentimentIcon = <img height={30} width={30} src={four} alt="4" />;
        break;
      case "Neutral":
        sentimentIcon = <img height={30} width={30} src={three} alt="3" />;
        break;
      case "Slightly Negative":
        sentimentIcon = <img height={30} width={30} src={two} alt="2" />;
        break;
      case "Negative":
        sentimentIcon = <img height={30} width={30} src={one} alt="1" />;
        break;
      default:
        sentimentIcon = "";
    }

    return sentimentIcon;
  }

  function renderRow(item, index) {
    return (
      <TableRow
        key={index}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell style={{ width: "400px" }} component="th" scope="row">
          <Typography variant="body2">
            {Array.isArray(item) && item.length
              ? `${index + 1}. ${trimBeforeInstructions(item[0].question)}`
              : index + 1}
          </Typography>
        </TableCell>
        {item.map((itemSentiment, index) => {
          return (
            <TableCell align="center" key={index}>
              <span
                className={classes.sentiment_emoji}
                onClick={() => {
                  if (itemSentiment.llm_sentiment) {
                    setShowSentimentModal(index + 1);
                    setSelectedSentiment({
                      number: index,
                      data: itemSentiment,
                    });
                  }
                }}
              >
                {itemSentiment?.sentiment !== undefined ||
                  itemSentiment?.sentiment != null
                  ? `Sentiment: ${itemSentiment?.sentiment}`
                  : getSentimentIcon(itemSentiment.llm_sentiment)}
              </span>
            </TableCell>
          );
        })}
      </TableRow>
    );
  }

  function renderHeader(sentiments) {
    return (
      <TableHead className={classes.table_header}>
        <TableRow>
          <TableCell>Question</TableCell>
          {sentiments.length &&
            sentiments[0].map((_, i) => (
              <TableCell align="center">Dataset {i + 1}</TableCell>
            ))}
        </TableRow>
      </TableHead>
    );
  }

  const pdfRef = useRef();

  const exportToPDF = useReactToPrint({
    contentRef: pdfRef,
    // documentTitle: `${pdfTitle}`,
    documentTitle: `xyz`,
    removeAfterPrint: true,
    pageStyle: `
            @page {
              size: 380mm 250mm;
              margin-left: 10mm;
              margin-right: 10mm;
              margin-bottom: 5mm;
              margin-top: 15mm;
            }
            @media print {
            .parent-container {
        overflow: hidden;
      }
              body {
                -webkit-print-color-adjust: exact; /* Ensures accurate color printing */
              }
              .page-footer {
                position: fixed;
                bottom: 10mm;
                left: 10mm;
                right: 10mm;
                font-size: 20pt;
                color: #777;
                text-align: center;
              }
            }
          `,
  });

  function renderSentimentScores(sentiment) {
    if (showScore && sentiment?.length > 0) {
      return (
        <>
          <hr />
          <h6>B. Average Sentiment Scores</h6>
          <hr />
          <Table sx={{ minWidth: 800 }} aria-label="simple table">
            <TableHead>
              <StyledTableRow>
                <StyledTableCell>Name</StyledTableCell>
                {data?.favorabilities &&
                  data?.favorabilities.length > 0 &&
                  Array.from({
                    length: Object.keys(data?.favorabilities?.[0])?.filter(
                      (key) => key.startsWith("sentiment")
                    ).length,
                  }).map((_, i) => (
                    <StyledTableCell align="right" key={i}>
                      Score {i + 1}
                    </StyledTableCell>
                  ))}
                <StyledTableCell align="right">Avg</StyledTableCell>
                {data?.favorabilities &&
                  data?.favorabilities.length > 0 &&
                  Object.keys(data?.favorabilities[0]).includes("score") && (
                    <StyledTableCell>Score</StyledTableCell>
                  )}
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {data?.favorabilities?.map((row) => (
                <StyledTableRow
                  key={row.name}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <StyledTableCell component="th" scope="row">
                    {row.name}
                  </StyledTableCell>
                  {data?.favorabilities &&
                    data?.favorabilities.length > 0 &&
                    Array.from({
                      length: Object.keys(data?.favorabilities?.[0])?.filter(
                        (key) => key.startsWith("sentiment")
                      ).length,
                    })?.map((_, i) => (
                      <StyledTableCell align="right" key={i}>
                        {row[`sentiment${i + 1}`]}
                      </StyledTableCell>
                    ))}
                  <StyledTableCell align="right">{row.average}</StyledTableCell>
                  {row.score && (
                    <StyledTableCell align="right">
                      {row?.score}
                    </StyledTableCell>
                  )}
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </>
      );
    }
  }

  return (
    <>
      <div id="sentiment_id">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h6>A. Sentiment Analysis</h6>
          {/* <DownloadIcon onClick={exportToPDF} style={{ cursor: "pointer" }} /> */}
        </div>

        <hr />
        <div style={{ display: "flex" }} id="print-pdf" ref={pdfRef}>
          <MUITable
            size="medium"
            elevation={0}
            data={sentiments}
            render={renderRow}
            renderHeaders={() => renderHeader(sentiments)}
          />
        </div>
      </div>
      <Modal
        handleClose={() => setShowSentimentModal(false)}
        open={showSentimentModal}
        title={`Sentiment: Question ${selectedSentiment?.number + 1
          } (Dataset ${showSentimentModal})`}
        width={850}
      >
        <SentimentItem sentiment={selectedSentiment?.data} />
      </Modal>
      {showScore && renderSentimentScores(sentiments)}
    </>
  );
}
